<template>
  <div>
    <b-card style="margin:20px">
      <b-row>
        <b-col cols="2" style="width:300px">
          <Sidebar></Sidebar>
        </b-col>
        <div class="mr-1" style="border:solid;width:1px"></div>

        <b-row>
          <h4 class="text-cente mx-3">Roles</h4>
          <br />
          <br />
        </b-row>

        <b-col class="mt-5" cols="6">
          <b-row>
            <b-col class="ma-1">
              <h5>Available Roles</h5>
              <b-list-group >
                <b-list-group-item @click="clickedRole(role)" v-for="role in roleList " :key="role" button>{{role}}</b-list-group-item>
                
              </b-list-group>
            </b-col>
            <b-col>
              <br />
              <br />
              <b-button @click="clickedMove()" variant="outline-primary" :disabled="!isMoveAvalable"> <b-icon icon="chevron-right "></b-icon></b-button>
              <br />
              <br />
              <b-button @click="clickedDelete()" variant="outline-primary" :disabled="!isDeleteAvailable"><b-icon icon="chevron-left "></b-icon></b-button>
            </b-col>
            <b-col>
              <h5>Assigned Roles</h5>
              <b-list-group>
               
                <b-list-group-item @click="clickedAvailableRole(role)" v-for="role in avalibleList " :key="role" button>{{role}}</b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { HTTP } from "../../https-common";
import Sidebar from "../AdminSlidebar";

export default {
  name: "RoleAssign",
  components: {
    Sidebar
  },
  created(){
    this.getRoles();
  },
  methods:{
    clickedRole(role){
      console.log("Going to move "+role)
      this.isMoveAvalable=true;
      this.moveRole=role;
    },
     clickedAvailableRole(role){
       console.log("Going to delete "+role)
      this.isDeleteAvailable=true;
      this.deleteRole=role;
    },
    clickedMove(){
      this.addRole(this.moveRole)
      
    },
    clickedDelete(){
      this.deleteRoleF(this.deleteRole);
    },
     getRoles() {
       console.log("getCalled");
      HTTP.get(`/roles/tenant`)
        .then(response => {
          console.log(response.data.data.roles)
          this.roleList=[];
          this.avalibleList=[]
          response.data.data.available.forEach(element => {
            this.avalibleList.push(element)
          });
          response.data.data.roles.forEach(element => {
            if(!this.avalibleList.includes(element)){
              // console.log(element)
              this.roleList.push(element)
            }
          });
          

        })
        .catch(e => {
          console.log(e)
          this.errors.push(e);
        });
    },
    addRole(roleName) {
      HTTP.post("/roles", {
        'name': roleName
      })
        .then(reposnse => {
          console.log(reposnse);
          this.isMoveAvalable=false;
          this.getRoles();
        })
        .catch(e => {
          console.log(e);
        });
    },
    deleteRoleF(roleName){
      console.log(roleName)
      HTTP.delete("/roles/user").then((response)=>{
        console.log(response)
        this.isDeleteAvailable=false;
        this.getRoles();
      }).catch(e=>{
        console.log(e)
      })
    }

  },
  data() {
    return {
      isMoveAvalable: false,
      isDeleteAvailable: false,
      moveRole:null,
      deleteRole:null,
      roleList: [],
      avalibleList: []
    };
  }
};
</script>

